import Vue from 'vue';
import GImageUser from '@/components/global/g-image-user';
import GModal from '@/components/global/modal/modal';

Vue.component('GImageUser', GImageUser);
Vue.component('GModal', GModal);
